import { ScriptLoadingStates, useScript } from "@/utils/hooks/useScript.hook";

type Props = { cmsIdentifier: string };

const ParcelPerform = ({ cmsIdentifier }: Props) => {
    const { status } = useScript(
        "https://tracking.parcelperform.com/pp-widget.js",
        "parcel-perform"
    );

    if (status === ScriptLoadingStates.Ready) {
        return (
            <div
                id="pp-widget-root"
                data-cms-slug={cmsIdentifier}
            ></div>
        );
    }
    return null;
};

export { ParcelPerform };
